// @flow
import * as React from 'react';
import type { Element } from 'react';

import { connect } from 'react-redux';

import LazyLoad from 'react-lazyload';

import Grid from 'styled-components-grid';

import type { GlobalState } from '@globalTypes';

import FooterContactInfo from './FooterContactInfo';
import FooterBottom from './FooterBottom';
import FooterLinks from './FooterLinks';

import { StyledFooter } from './styles';

import type { Props } from './types';

const Footer = ({ footerVisibility, curefyDomain }: Props): Element<any> => {
  if (!footerVisibility) return <></>;
  if (curefyDomain) {
    return (
      <StyledFooter height="100%" once curefyDomain={curefyDomain}>
        <LazyLoad>
          <Grid>
            <Grid.Unit size={1}>
              <Grid halign="justify-center">
                <Grid.Unit size={{ mobile: 1, desktop: 1 / 3 }}>
                  <FooterContactInfo curefyDomain={curefyDomain} />
                </Grid.Unit>
                <Grid.Unit size={{ mobile: 1, desktop: 2 / 3 }}>
                  <FooterLinks curefyDomain={curefyDomain} />
                </Grid.Unit>
              </Grid>
            </Grid.Unit>

            <Grid.Unit size={1}>
              <FooterBottom curefyDomain={curefyDomain} />
            </Grid.Unit>
          </Grid>
        </LazyLoad>
      </StyledFooter>
    );
  }

  return (
    <StyledFooter height="100%" once>
      <LazyLoad>
        <Grid>
          <Grid.Unit size={1}>
            <Grid halign="justify-center">
              <Grid.Unit size={{ mobile: 1, desktop: 1 / 3 }}>
                <FooterContactInfo curefyDomain={curefyDomain} />
              </Grid.Unit>
              <Grid.Unit size={{ mobile: 1, desktop: 2 / 3 }}>
                <FooterLinks curefyDomain={curefyDomain} />
              </Grid.Unit>
            </Grid>
          </Grid.Unit>

          <Grid.Unit size={1}>
            <FooterBottom curefyDomain={curefyDomain} />
          </Grid.Unit>
        </Grid>
      </LazyLoad>
    </StyledFooter>
  );
};

Footer.getInitialProps = () => ({
  namespacesRequired: ['Footer'],
});

const mapStateToProps = ({ page }: GlobalState): {} => ({
  footerVisibility: page.footerVisibility,
  curefyDomain: page.curefyDomain
});

export default connect(mapStateToProps)(Footer);
